import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { GAME_CARDS } from '../main/constants';
import { ModeCardComponent } from '../main/components/mode-card/mode-card.component';
import { RouterLink } from '@angular/router';
import { AuthState } from '@app/modules/users';
import { MainState } from '../main/main.state';
import { LiveDropComponent } from '../main/components/live-drop/live-drop.component';
import { PreloadRectComponent } from '@app/@core/common/directives';
import { MainService } from '../main/main.service';
import { BrowserApiService } from '@app/@core/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'games-page',
  templateUrl: './games.component.html',
  styleUrl: './games.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MainState, MainService],
  host: {
    class: 'flex items-center justify-center w-full'
  },
  imports: [ModeCardComponent, RouterLink, LiveDropComponent, PreloadRectComponent]
})
export default class GamesComponent {
  public readonly mainState = inject(MainState);
  public readonly authState = inject(AuthState);
  private readonly destroyRef = inject(DestroyRef);
  public readonly isServer = inject(BrowserApiService).isServer();
  public readonly preloadLiveDrops = new Array(6);
  public readonly GAME_CARDS = GAME_CARDS;


  constructor() {
    this.loadData();
  }

  private loadData(): void {
    this.mainState.fetchLiveDrops().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();

    if (!this.isServer) {
      this.mainState.fetchBanners().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    }
  }
}
